import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LocalStorageKey } from "../../constants/localStorageKeys";
import { getSideBottomMenu, getSideMenu } from "../../services/layoutServices";

interface ILayoutState
{
  expanded?: boolean;
  layoutName?: string;
  dataBreadcrumb?: any;
  sideMenuConfig?: any;
  sideBottomMenuConfig?: any
}

const getExpandedFromLocal = (): boolean =>
{
  const stored = window.localStorage.getItem(LocalStorageKey.EXPAND);
  // Default to expanded when nothing has been saved yet.
  return stored === null ? true : stored === "true";
};

const initialState: ILayoutState = {
  expanded: getExpandedFromLocal(),
  layoutName: "",
  dataBreadcrumb: [],
  sideMenuConfig: undefined,
  sideBottomMenuConfig: undefined
};



export const layoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    changeExpanded: (state, action: PayloadAction<boolean>) =>
    {
      state.expanded = action.payload;
      window.localStorage.setItem(LocalStorageKey.EXPAND, String(action.payload));
    },
    changeLayoutName: (state, action: PayloadAction<string>) =>
    {
      state.layoutName = action.payload;
    },

    changeDataBreadcrumb: (
      state,
      action: PayloadAction<
        {
          title: string | any;
          path?: string;
        }[]
      >
    ) =>
    {
      state.dataBreadcrumb = action.payload;
    },

    setSideMenuConfig: (state, action) =>
    {
      state.sideMenuConfig = action?.payload;
    },
    setSideBottomMenuConfig: (state, action) =>
    {
      state.sideBottomMenuConfig = action?.payload;
    },
  },
});

export const getSideMenuAsync = createAsyncThunk(
  "getSideMenu",
  async (payload) =>
  {
    try
    {
      const response = await getSideMenu();
      return response.data;
    } catch (e: any)
    {
      //! can fix
      return e?.response?.data;
      // return [];
    }
  }
);

export const getSideBottomMenuAsync = createAsyncThunk(
  "getSideBottomMenu",
  async (payload) =>
  {
    try
    {
      const response = await getSideBottomMenu();
      return response.data;
    } catch (e: any)
    {
      //! can fix
      return e?.response?.data;
      // return [];
    }
  }
);

export const { changeExpanded, changeLayoutName, changeDataBreadcrumb, setSideMenuConfig, setSideBottomMenuConfig } =
  layoutSlice.actions;

export default layoutSlice.reducer;
